import { initializeApp, type FirebaseApp } from 'firebase/app';
import { memoize } from '@softgames/async-utils';

let app: FirebaseApp | null = null;

export const initFirebase = memoize(async () => {
    const isDev = ENVIRONMENT === 'dev';
    const firebaseConfig = isDev
        ? {
            apiKey: 'AIzaSyBiOTTb37dXPNVPrUpww8FFe4gd_s8iSg8',
            authDomain: 'hexa-stack-development.firebaseapp.com',
            projectId: 'hexa-stack-development',
            storageBucket: 'hexa-stack-development.firebasestorage.app',
            messagingSenderId: '132926261641',
            appId: '1:132926261641:web:0f0789639696f2f6f3f958',
        }
        : {
            apiKey: 'AIzaSyAV_aR1-GEV3n7lLYC8_Hto_g6ihdf-j0A',
            authDomain: 'hexa-stack-production.firebaseapp.com',
            projectId: 'hexa-stack-production',
            storageBucket: 'hexa-stack-production.appspot.com',
            messagingSenderId: '195630231683',
            appId: '1:195630231683:web:01010622425c3e1fd0abb6',
        };

    try {
        app = initializeApp(firebaseConfig);
    } catch (error) {
        console.error('Failed to initialize Firebase:', error);
    }
});

export function getFirebaseAppOrNull(): FirebaseApp | null {
    return app;
}
